<template>
  <div>
    <div class="wz-page-header">
      <h1 class="wz-page-title">{{ editing ? "Editar sede" : "Nueva sede" }}</h1>
    </div>

    <form @submit.prevent="save" novalidate>
      <wz-card :title="editing ? 'Datos de la sede' : 'Datos de la nueva sede'">
        <div class="flex flex-wrap -mx-2">
          <div class="w-full md:w-2/3 mb-3 px-2">
            <wz-select
              label="Empresa"
              required
              :items="companies"
              :value="form.companyId"
              defaultOption="Seleccione empresa"
              :disabled="editing"
              :error="$v.form.companyId.$error && !$v.form.companyId.required ? 'La empresa es requerida' : ''"
              @change="form.companyId = $event"
            />
          </div>
          <div v-if="editing" class="w-full md:w-1/3 mb-3 px-2">
            <wz-input label="Código" :disabled="true" v-model="form.code" />
          </div>
          <div class="w-full mb-3 px-2">
            <wz-input
              label="Nombre"
              required
              v-model="form.name"
              placeholder="Nombre de la sede"
              :error="$v.form.name.$error && !$v.form.name.required ? 'El nombre es requerido' : ''"
            />
          </div>
          <div class="w-full mb-3 px-2">
            <wz-textarea label="Dirección" v-model="form.address" placeholder="Dirección de la sede" :rows="3" />
          </div>
        </div>

        <div class="flex justify-end gap-2 mt-2">
          <wz-button type="button" variant="light" @click="$router.push({ name: 'work-site-list' })">{{ editing ? "Volver" : "Cancelar" }}</wz-button>
          <wz-button type="submit" variant="primary" class="ml-2">Guardar</wz-button>
        </div>
      </wz-card>
    </form>

    <!-- CDEF010: campos personalizados de la entidad (solo en edición) -->
    <wz-card v-if="editing && $route.params.id" class="mt-3">
      <custom-fields-section entity="SEDE" :entity-id="Number($route.params.id)" />
    </wz-card>
  </div>
</template>

<script>
import { Alert } from "@wizepe/wizeui"
import { required } from 'vuelidate/lib/validators'
import { WorkSiteService, CompanyService } from '@/core/services'
import CustomFieldsSection from '@/core/components/CustomFieldsSection.vue'

export default {
  components: { CustomFieldsSection },
  data() {
    return { editing: false, companies: [], form: { companyId: null, name: null, code: null, address: null } }
  },
  validations: { form: { companyId: { required }, name: { required } } },
  watch: { '$route.params.id'() { if (this.$route.params.id) this.load(this.$route.params.id) } },
  methods: {
    async save() {
      this.$v.$touch()
      if (this.$v.$error) {
        this.$nextTick(() => { const el = document.querySelector('.wz-form-error-msg'); if (el) this.$smoothScroll({ scrollTo: el, updateHistory: false, offset: -50 }) })
        return
      }
      try {
        this.$store.dispatch('app/loading', true)
        const data = { companyId: this.form.companyId, name: this.form.name, code: this.form.code || null, address: this.form.address || null }
        let response
        if (!this.editing) response = await WorkSiteService.save(data)
        else response = await WorkSiteService.update(this.$route.params.id, data)
        Alert.success('Se almacenó la información correctamente')
        if (!this.editing) { this.$router.push({ name: 'work-site-edit', params: { id: response.payload.id } }); this.editing = true }
      } catch (ex) { console.error(ex); Alert.error(ex.errors ? ex.errors.message : 'Error al guardar') }
      finally { this.$store.dispatch('app/loading', false) }
    },
    async load(id) {
      try {
        this.$store.dispatch('app/loading', true)
        const payload = (await WorkSiteService.get(id)).payload
        this.form = { companyId: payload.company ? payload.company.id : null, name: payload.name, code: payload.code, address: payload.address }
        this.editing = true
      } catch (e) { console.error(e); Alert.error(e.errors ? e.errors.message : 'Error al cargar'); this.$router.push({ name: 'work-site-list' }) }
      finally { this.$store.dispatch('app/loading', false) }
    },
  },
  async created() {
    const resp = await CompanyService.listAll()
    this.companies = (resp.payload || []).map(c => ({ key: c.id, label: c.name }))
    if (this.$route.params.id) this.load(this.$route.params.id)
  },
}
</script>
